/* eslint-disable react/jsx-props-no-spreading */
import React from 'react'
import { connect } from 'react-redux'

// Components
import GenerateOrganizationCertificates from 'app/views/components/GenerateOrganizationCertificates'
import Loader from 'app/views/components/Loader'
import Icon from 'app/views/components/Icon'
import OrganizationLayout from 'app/views/containers/Organizations/components/Layout'

// Redux
import { getOrganizations, getTeamDetails } from 'app/state/modules/hacker'


class OrganizationReports extends React.Component {
  constructor(props) {
    super(props)
    this.onClickReport = this.onClickReport.bind(this)
  }

  componentDidMount() {
    if (!this.props.hasLoadedOrganizations) {
      this.props.getOrganizations()
    }
    this.props.getTeamDetails(this.props.match.params.organization_uuid)
  }

  onClickReport(e) {
    if (e.target.name) {
      this.props.history.push(`/admin/${this.props.match.params.organization_uuid}/reports/${e.target.name}`)
    }
  }

  render() {
    if (!this.props.hasLoadedOrganizations) {
      return <Loader visible />
    }

    return (
      <OrganizationLayout data-test-id="organization-users-component" active="reports" {...this.props}>
        <h1>Reports</h1>
        <table className="uk-table uk-table-middle">
          <thead>
            <tr>
              <th style={{ width: '25%' }} />
              <th style={{ width: '5%' }} />
              <th className="uk-margin-left" style={{ width: '30%' }} />
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <button
                  type="button"
                  className="uk-button uk-button-primary uk-width-1-1 uk-position-relative uk-flex uk-flex-center uk-flex-middle"
                  onClick={this.onClickReport}
                  name="download"
                >
                  <Icon style={{ position: 'absolute', left: 20 }} name="download-cloud" />
                  &nbsp;
                  CSV Download
                </button>
              </td>
              <td />
              <td className="uk-text-small">
                Export all lesson data for your organization as a single CSV.
              </td>
            </tr>
            {/*
            <tr>
              <td>
                <GenerateOrganizationCertificates
                  data-test-id="download-certificate-card"
                  style={{
                    cursor: 'pointer',
                    height: '100%',
                  }}
                  className="uk-button uk-button-primary uk-width-1-1 uk-position-relative uk-flex uk-flex-center uk-flex-middle"
                  organizationUUID={this.props.match.params.organization_uuid}
                >

                  <Icon style={{ position: 'absolute', left: 20 }} name="download-cloud" />
                  &nbsp;
                  Certificate (PDF)
                </GenerateOrganizationCertificates>
              </td>
              <td />
              <td className="uk-text-small">
                An official HackEDU Certificate for all users who have
                completed the OWASP Top 10 training plan.
              </td>
            </tr>
            */}
            <tr>
              <td>
                <button
                  type="button"
                  className="uk-button uk-button-primary uk-width-1-1 uk-position-relative uk-flex uk-flex-center uk-flex-middle"
                  onClick={this.onClickReport}
                  name="completed"
                >
                  <Icon style={{ position: 'absolute', left: 20 }} name="link" none />
                  &nbsp;
                  Completion Report
                </button>
              </td>
              <td />
              <td className="uk-text-small">
                See the training completion status of all users, and see who is
                past due.
              </td>
            </tr>
            <tr>
              <td>
                <button
                  type="button"
                  className="uk-button uk-button-primary uk-width-1-1 uk-position-relative uk-flex uk-flex-center uk-flex-middle"
                  onClick={this.onClickReport}
                  name="proficiency"
                >
                  <Icon style={{ position: 'absolute', left: 20 }} name="link" none />
                  &nbsp;
                  Proficiency Report
                </button>
              </td>
              <td />
              <td className="uk-text-small">
                Break down all of the training that has been completed by
                Proficiency level to see where your team is excelling and where
                they could use some extra attention.
              </td>
            </tr>
            <tr>
              <td>
                <button
                  type="button"
                  className="uk-button uk-button-primary uk-width-1-1 uk-position-relative uk-flex uk-flex-center uk-flex-middle"
                  onClick={this.onClickReport}
                  name="challenges"
                >
                  <Icon style={{ position: 'absolute', left: 20 }} name="link" none />
                  &nbsp;
                  Challenge Report
                </button>
              </td>
              <td />
              <td className="uk-text-small">
                See which challenges your developers have completed.
              </td>
            </tr>
            <tr>
              <td>
                <button
                  type="button"
                  className="uk-button uk-button-primary uk-width-1-1 uk-position-relative uk-flex uk-flex-center uk-flex-middle"
                  onClick={this.onClickReport}
                  name="users"
                >
                  <Icon style={{ position: 'absolute', left: 20 }} name="link" none />
                  &nbsp;
                  Users Report
                </button>
              </td>
              <td />
              <td className="uk-text-small">
                Information about all the users in your organization and their
                progress.
              </td>
            </tr>
          </tbody>
        </table>
      </OrganizationLayout>
    )
  }
}

const mapStateToProps = (state) => ({
  hasLoadedOrganizations: state.hacker.hasLoadedOrganizations,
  organizationsHash: state.hacker.organizationsHash,
  organizations: state.hacker.organizationsList,
  email: state.auth.user.email,

})

export default connect(mapStateToProps, {
  getOrganizations,
  getTeamDetails,
})(OrganizationReports)
